

import { lazy } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Navigate } from "react-router-dom";

const Config = lazy(() => import("../components/config"));
const ConfigList = lazy(() => import("../components/configList"));

const configRoute = {
  icon: SettingsIcon,
  name: "Settings",
  path: "settings",
  link: "/settings",
  index: 25,
  children: [
    {
      path: "config",
      element: <ConfigList />,
      name: "Config",
      link: "/settings/config",
      icon: AdminPanelSettingsIcon,
      permission: "Config-Read",
      index: 2,
    },
    {
      path: "config/create",
      element: <Config />,
    },
    {
      path: "config/:id",
      element: <Config />,
    },
    {
      path: "",
      element: <Navigate to="config" replace />,
    },
  ],
};
export default configRoute;
